<template>
  <v-container v-if="diaryBookData" fluid class="pa-6 bg-light-soft min-h-screen">
    <!-- Controles de Filtro -->
    <v-row align="center" justify="center" class="pb-2">
      <!-- Filtro: Unidad de Negocio -->
      <v-col md="2" class="pt-0">
        <v-autocomplete v-model="business_filter" outlined dense :disabled="loading" hide-details :items="itemsBussines"
          label="Unidad de Negocio"></v-autocomplete>
      </v-col>

      <!-- Filtro: Location/Ubicación -->
      <v-col md="2" class="pt-0">
        <v-autocomplete v-model="location_filter" outlined dense :disabled="loading" hide-details :items="locations"
          label="Ubicación"></v-autocomplete>
      </v-col>

      <!-- Filtro: Rango de Fechas -->
      <v-col md="2" class="pt-0">
        <v-select v-model="rangeSelected_filter" outlined dense :disabled="loading" hide-details :items="dateRanges"
          label="Rango de Fechas">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-calendar-range</v-icon>
          </template>
        </v-select>
      </v-col>

      <!-- Fechas personalizadas -->
      <v-col md="auto" class="pt-0" v-if="rangeSelected_filter == '7'">
        <div class="date-range-wrapper">
          <v-menu v-model="menu_dateStart_filter" :close-on-content-click="false" transition="scale-transition"
            offset-y min-width="auto" max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="dateStart_filterDMY" label="Desde" readonly v-bind="attrs" v-on="on"
                outlined dense :disabled="loading" hide-details color="primary" class="date-input">
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="18">mdi-calendar-start</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="dateStart_filter" @input="menu_dateStart_filter = false" locale="es"></v-date-picker>
          </v-menu>

          <v-icon size="16" color="grey lighten-1" class="date-separator">mdi-arrow-right</v-icon>

          <v-menu v-model="menu_dateEnd_filter" :close-on-content-click="false" transition="scale-transition"
            offset-y min-width="auto" max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="dateEnd_filterDMY" label="Hasta" readonly v-bind="attrs" v-on="on"
                outlined dense :disabled="loading" hide-details color="primary" class="date-input">
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="18">mdi-calendar-end</v-icon>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="dateEnd_filter" @input="menu_dateEnd_filter = false" locale="es"></v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <!-- NUEVOS FILTROS -->
    </v-row>
    <v-row align="center" justify="center" class="pb-2">

      <!-- Filtro: Cuenta Contable Y MONEDA -->
      <v-col md="3" class="pt-0">
        <v-row>
          <v-col md="6">
            <v-autocomplete v-model="filters.account" :items="accounts" label="Cuenta contable" color="primary"
              item-color="primary" outlined dense hide-details multiple clearable placeholder="Todas"
              persistent-placeholder>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate" style="max-width: 75%">{{ item.text }}</span>
                <span v-if="index === 1" class="grey--text text-caption ml-1">(+{{ filters.account.length - 1 }})</span>
              </template>
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-book-open-page-variant</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="6">
            <v-autocomplete v-model="currency_selected" :items="currencies" label="Moneda" color="primary"
              item-color="primary" outlined dense hide-details multiple clearable placeholder="Todas"
              persistent-placeholder>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate" style="max-width: 75%">{{ item.code }}</span>
                <span v-if="index === 1" class="grey--text text-caption ml-1">(+{{ currency_selected.length - 1 }})</span>
              </template>
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-domain</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>

      <!-- Filtro: Departamento Y TIPO ENTRADA -->
      <v-col md="3" class="pt-0">
        <v-row>
          <v-col md="6">
            <v-autocomplete v-model="department_selected" :items="itemsDepartment" label="Departamento" color="primary"
              item-color="primary" outlined dense hide-details multiple clearable placeholder="Todos"
              persistent-placeholder>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate" style="max-width: 75%">{{ item.text }}</span>
                <span v-if="index === 1" class="grey--text text-caption ml-1">(+{{ department_selected.length - 1 }})</span>
              </template>
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-domain</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="6">
            <v-autocomplete v-model="filters.type_account" :items="type_accounts" label="Tipo libro" color="primary"
              item-color="primary" outlined dense hide-details item-text="description" item-value="id"
              multiple clearable placeholder="Todas" persistent-placeholder>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate" style="max-width: 75%">{{ item.description }}</span>
                <span v-if="index === 1" class="grey--text text-caption ml-1">(+{{ filters.type_account.length - 1 }})</span>
              </template>
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-book-variant</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>

      <!-- Filtro: Categoría -->
      <v-col md="3" class="pt-0">
        <v-row>
          <v-col md="6">
            <v-autocomplete v-model="filters.category"
              :items="categories.filter((element) => element.parent_id === null)" label="Categoría" color="primary"
              item-color="primary" outlined dense hide-details item-text="name" item-value="id"
              @change="filters.sub_category = null, updateData(true)">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-shape</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="6">
            <v-autocomplete v-model="filters.sub_category" :items="categories.filter((element) => element.parent_id === filters.category)
              " label="Sub categoría" color="primary" item-color="primary" outlined dense hide-details item-text="name"
              item-value="id" @change="updateData(true)">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-shape-outline</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>

      <!-- Botón de Actualizar -->
      <v-col md="2" align="start" jutify="center" class="pt-0">
        <v-btn color="primary" @click="updateData(true)" :loading="loading" rounded elevation="3" medium>
          <v-icon left size="20">mdi-refresh</v-icon>
          <span class="font-weight-medium">Actualizar</span>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Fin Controles de Filtro -->

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="pt-0">
            <!-- Tabla de datos de Vuetify con configuración de servidor -->
            <v-data-table :headers="headers" :items="diaryBookData" :options.sync="dataPaginationOptions"
              :server-items-length="totalItems" :loading="loading" loading-text="Cargando datos..."
              :no-data-text="!business_filter ? 'Por favor, seleccione una Unidad de Negocio para ver las transacciones.' : 'No se encontraron transacciones para los filtros seleccionados.'"
              :hide-default-footer="true" hide-default-footer>
              <!-- @click:close="chip3 = false" -->
              <template v-slot:top>
                <v-toolbar flat class="py-0 my-0">
                  <v-chip v-if="diaryBookId != null" class="py-0 my-0" close dense small color="primary" outlined
                    hide-details @click:close="reset_find()">
                    Asiento: {{ diary_book_code_find || '' }}
                  </v-chip>
                  <v-chip v-if="filters.account.length" class="py-0 my-0" close dense small color="primary" outlined
                    hide-details @click:close="filters.account = []">
                    Cuenta: {{ selectedLabel(accounts, filters.account, 'value', 'text', 'cuentas') }}
                  </v-chip>
                  <v-chip v-if="currency_selected.length" class="py-0 my-0 mx-1" close dense small color="primary"
                    outlined hide-details @click:close="currency_selected = []">
                    Moneda: {{ selectedLabel(currencies, currency_selected, 'value', 'text', 'monedas') }}
                  </v-chip>
                  <v-chip v-if="department_selected.length" class="py-0 my-0 mx-1" close dense small color="primary"
                    outlined hide-details @click:close="department_selected = []">
                    Dep.: {{ selectedLabel(itemsDepartment, department_selected, 'value', 'text', 'departamentos') }}
                  </v-chip>
                  <v-chip v-if="filters.type_account.length" class="py-0 my-0 mx-1" close dense small color="primary"
                    outlined hide-details @click:close="filters.type_account = []">
                    Tipo: {{ selectedLabel(type_accounts, filters.type_account, 'id', 'description', 'tipos') }}
                  </v-chip>

                  <v-chip v-if="filters.category != null" class="py-0 my-0 mx-1" close dense small color="primary"
                    outlined hide-details @click:close="filters.category = null; filters.sub_category = null">
                    Categoria: {{categories.find(cat => cat.id === filters.category)?.name || ''}}
                  </v-chip>

                  <v-chip v-if="filters.sub_category != null" class="py-0 my-0 mx-1" close dense small color="primary"
                    outlined hide-details @click:close="filters.sub_category = null">
                    Sub Cat. {{categories.find(subcat => subcat.id === filters.sub_category)?.name || ''}}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-btn rounded outlined @click="dialog_search = true" color="primary">
                    Buscar <v-icon>search</v-icon>
                  </v-btn>
                  <v-btn rounded outlined class="ml-3" @click="exportDiaryBookToExcel()" color="success"
                    :loading="loading_report">
                    <v-icon>download</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.diary_book_code`]="{ item }">
                <v-col cols="12">
                  <v-hover v-slot="{ hover }">
                    <span @click="view_entry(item, true)"
                      class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                        color: hover ? 'red' : 'black',
                        cursor: hover ? 'pointer' : '',
                        'text-decoration': hover ? 'underline' : '',
                      }">
                      {{ item.diary_book_code }}
                    </span>
                  </v-hover>
                </v-col>
              </template>
              <template v-slot:[`item.view_diary_type_detail`]="{ item }">
                <v-col cols="12">
                  <v-hover v-slot="{ hover }">
                    <span @click="showItem(item, true)"
                      class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                        color: hover ? 'red' : 'black',
                        cursor: hover ? 'pointer' : '',
                        'text-decoration': hover ? 'underline' : '',
                      }">
                      VER {{ item.diary_book_type_name }}
                    </span>
                  </v-hover>
                </v-col>
              </template>
              <template v-slot:[`item.department_name`]="{ item }">
                <v-col cols="12">
                  <v-hover v-slot="{ hover }">
                    <span>
                      {{ item.department_id != 0 ? `(${item.department_id})` : '' }} {{ item.department_name }}
                    </span>
                  </v-hover>
                </v-col>
              </template>
              <template v-slot:[`item.debit`]="{ item }">
                <span style="color: green" v-if="item.entry_type_id == 1">
                  {{ item.currency_code }} {{ currencyFormat(item.amount) }}
                </span>
              </template>
              <template v-slot:[`item.credit`]="{ item }">
                <span style="color: red" v-if="item.entry_type_id == 2">
                  {{ item.currency_code }} {{ currencyFormat(item.amount) }}
                </span>
              </template>
              <!-- Footer personalizado con paginación -->
              <template v-slot:footer>
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination v-model="currentPage" :length="pageCount" :total-visible="7" color="primary"
                      prev-icon="mdi-menu-left" next-icon="mdi-menu-right"></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <!-- Resumen de Totales -->
        <v-fade-transition>
          <div v-if="Object.keys(groupedSummary).length > 0" class="mt-6">
            <!-- Summary Header Section -->
            <v-row align="center" class="mb-4 mx-0">
              <v-col cols="auto">
                <div class="d-flex align-center">
                  <v-avatar color="primary" size="40" class="mr-3 elevation-2">
                    <v-icon color="white">mdi-calculator-variant</v-icon>
                  </v-avatar>
                  <div>
                    <h2 class="text-h6 font-weight-bold grey--text text--darken-3 mb-0">Resumen de Totales</h2>
                    <span class="text-caption grey--text">Consolidado por tipo de moneda</span>
                  </div>
                  <v-btn small text color="error" class="ml-4 text-none font-weight-bold border-error"
                    @click="findUnbalancedEntries" :loading="loadingUnbalanced"
                    v-if="Object.keys(groupedSummary).length > 0">
                    <v-icon left small>mdi-alert-circle-outline</v-icon>
                    Buscar Descuadres
                  </v-btn>
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-card class="modern-card pa-1" elevation="1">
                  <div class="d-flex align-center px-3 py-1">
                    <div class="d-flex align-center mr-4">
                      <v-icon small color="success" class="mr-1">mdi-arrow-up-circle</v-icon>
                      <span class="text-caption font-weight-bold grey--text text--darken-2 mr-2">DÉBITO:</span>
                      <span class="text-subtitle-2 font-weight-black success--text">USD {{
                        currencyFormat(baseAmountTotals.totalBaseDebit) }}</span>
                    </div>
                    <v-divider vertical class="mx-2"></v-divider>
                    <div class="d-flex align-center mr-4">
                      <v-icon small color="error" class="mr-1">mdi-arrow-down-circle</v-icon>
                      <span class="text-caption font-weight-bold grey--text text--darken-2 mr-2">CRÉDITO:</span>
                      <span class="text-subtitle-2 font-weight-black error--text">USD {{
                        currencyFormat(baseAmountTotals.totalBaseCredit) }}</span>
                    </div>
                    <template v-if="baseAmountTotals.totalNeto != 0">
                      <v-divider vertical class="mx-2"></v-divider>
                      <div class="d-flex align-center">
                        <v-icon small color="info" class="mr-1">mdi-scale-balance</v-icon>
                        <span class="text-caption font-weight-bold grey--text text--darken-2 mr-2">NETO:</span>
                        <span class="text-subtitle-2 font-weight-black info--text">USD {{
                          currencyFormat(baseAmountTotals.totalNeto) }}</span>
                      </div>
                    </template>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Currency Totals Grid -->
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3" v-for="(totals, currencyCode) in groupedSummary"
                :key="currencyCode">
                <v-card class="modern-card overflow-hidden h-100" elevation="2">
                  <div class="pa-3 primary white--text font-weight-bold d-flex align-center">
                    <v-icon small color="white" class="mr-2">mdi-currency-usd</v-icon>
                    {{currencies.find(cur => cur.code === currencyCode)?.text || currencyCode}}
                    <v-spacer></v-spacer>
                    <v-chip x-small color="rgba(255,255,255,0.2)" dark class="font-weight-black">{{ currencyCode
                      }}</v-chip>
                  </div>

                  <v-card-text class="pa-0">
                    <v-list dense class="pa-0">
                      <!-- Debito Section -->
                      <v-list-item class="px-3 py-2 border-bottom">
                        <v-list-item-avatar size="32" color="success lighten-5" class="mr-3">
                          <v-icon small color="success">mdi-arrow-up</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div class="d-flex justify-space-between align-center">
                            <span class="text-overline font-weight-bold success--text">DÉBITO</span>
                            <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                              {{ currencyCode }} {{ currencyFormat(totals.DEBITO ? totals.DEBITO.amount : 0) }}
                            </span>
                          </div>
                          <div class="text-caption grey--text d-flex justify-end mt-n1">
                            Equivalente: USD {{ currencyFormat(totals.DEBITO ? totals.DEBITO.base : 0) }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- Credito Section -->
                      <v-list-item class="px-3 py-2">
                        <v-list-item-avatar size="32" color="error lighten-5" class="mr-3">
                          <v-icon small color="error">mdi-arrow-down</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div class="d-flex justify-space-between align-center">
                            <span class="text-overline font-weight-bold error--text">CRÉDITO</span>
                            <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                              {{ currencyCode }} {{ currencyFormat(totals.CREDITO ? totals.CREDITO.amount : 0) }}
                            </span>
                          </div>
                          <div class="text-caption grey--text d-flex justify-end mt-n1">
                            Equivalente: USD {{ currencyFormat(totals.CREDITO ? totals.CREDITO.base : 0) }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <!-- Balance / Neto Indicator -->
                    <div class="px-3 py-2 grey lighten-5 border-top">
                      <div class="d-flex justify-space-between align-center">
                        <span class="text-caption font-weight-bold grey--text">BALANCE NETO</span>
                        <v-chip x-small
                          :color="(totals.DEBITO ? parseFloat(totals.DEBITO.base) : 0) - (totals.CREDITO ? parseFloat(totals.CREDITO.base) : 0) >= 0 ? 'success' : 'error'"
                          dark class="font-weight-black">
                          USD {{ currencyFormat((totals.DEBITO ? parseFloat(totals.DEBITO.base) : 0) -
                            (totals.CREDITO ? parseFloat(totals.CREDITO.base) : 0)) }}
                        </v-chip>
                      </div>
                      <div class="d-flex justify-end mt-1">
                        <span class="text-caption grey--text">
                          {{ currencyCode }} {{ currencyFormat((totals.DEBITO ? parseFloat(totals.DEBITO.amount) : 0) -
                            (totals.CREDITO ? parseFloat(totals.CREDITO.amount) : 0)) }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-fade-transition>

        <!-- Analytical Dashboard Section -->
        <v-fade-transition>
          <div v-if="dashboardData && !loadingDashboard" class="mt-8">
            <v-row align="center" class="mb-2 px-3">
              <v-icon color="primary" class="mr-3">mdi-chart-areaspline</v-icon>
              <h2 class="text-h5 font-weight-black grey--text text--darken-3 mb-0">Análisis y Auditoría del Diario</h2>
              <v-spacer></v-spacer>

            </v-row>

            <!-- KPI Cards -->
            <v-row class="mb-2">
              <v-col cols="12" sm="6" md="3">
                <StatsCard color="indigo" icon="mdi-book-open-variant" title="Total Transacciones"
                  :value="dashboardData.stats.total_entries" :small-value="entriesTrend ? entriesTrend.val + '%' : ''"
                  :small-value-icon="entriesTrend ? entriesTrend.icon : ''"
                  :small-value-color="entriesTrend ? entriesTrend.color : ''" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <StatsCard color="orange" icon="mdi-account-edit-outline" title="Asientos Manuales"
                  :value="dashboardData.stats.manual_entries" :progress-value="calculateManualPct"
                  progress-color="orange" :small-value="calculateManualPct + '%'" small-value-icon="mdi-percent"
                  small-value-color="orange--text" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <StatsCard color="success" icon="mdi-swap-horizontal" title="Volumen Base (USD)"
                  :value="currencyFormat(dashboardData.stats.total_volume_base)"
                  :small-value="volumeTrend ? volumeTrend.val + '%' : ''"
                  :small-value-icon="volumeTrend ? volumeTrend.icon : ''"
                  :small-value-color="volumeTrend ? volumeTrend.color : ''" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <StatsCard color="error" icon="mdi-scale-balance" title="Estado Balance"
                  :value="baseAmountTotals.totalNeto === 0 ? 'Balanceado' : 'Descuadrado'"
                  :small-value="baseAmountTotals.totalNeto === 0 ? 'OK' : 'Error'"
                  :small-value-icon="baseAmountTotals.totalNeto === 0 ? 'mdi-check' : 'mdi-alert'"
                  :small-value-color="baseAmountTotals.totalNeto === 0 ? 'success--text' : 'error--text'" />
              </v-col>
            </v-row>

            <!-- Charts Row -->
            <v-row class="mb-2">
              <v-col cols="12" md="8">
                <v-card class="rounded-xl border-soft shadow-sm pa-4 h-full bg-white" elevation="0">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="primary" small class="mr-2">mdi-chart-line</v-icon>
                    <span class="text-subtitle-2 font-weight-black grey--text text--darken-2">TENDENCIA DIARIA</span>
                  </div>
                  <LineChart :data="dashboardData.trend" :title_header="''" height="300" />
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="rounded-xl border-soft shadow-sm pa-4 h-full bg-white" elevation="0">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="orange" small class="mr-2">mdi-chart-pie</v-icon>
                    <span class="text-subtitle-2 font-weight-black grey--text text--darken-2">DISTRIBUCIÓN ORIGEN</span>
                  </div>
                  <PieChart :data="dashboardData.origin" :title_header="''" height="300"
                    @selection="onOriginSelection" />
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <v-card class="rounded-xl border-soft shadow-sm pa-4 bg-white" elevation="0"
                  style="height: 400px; overflow: hidden;">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="indigo" small class="mr-2">mdi-account-group</v-icon>
                    <span class="text-subtitle-2 font-weight-black grey--text text--darken-2">ASIENTOS POR
                      USUARIO</span>
                  </div>
                  <PieChart :data="dashboardData.users" :title_header="''" height="300" />
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="rounded-xl border-soft shadow-sm pa-4 bg-white" elevation="0"
                  style="height: 400px; overflow: hidden;">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="teal" small class="mr-2">mdi-bank</v-icon>
                    <span class="text-subtitle-2 font-weight-black grey--text text--darken-2">ESTRUCTURA
                      FINANCIERA</span>
                  </div>
                  <PieChart :data="dashboardData.financialStructure" :title_header="''" height="300" />
                </v-card>
              </v-col>
              <!-- <v-col cols="12" md="12">
                <v-card class="rounded-xl border-soft shadow-sm pa-4 bg-white" elevation="0"
                  style="height: 400px; display: flex; flex-direction: column;">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="error" small class="mr-2">mdi-alert-decagram</v-icon>
                    <span class="text-subtitle-2 font-weight-black grey--text text--darken-2">POSIBLES ANOMALÍAS (TOP
                      MONTOS)</span>
                    <v-spacer></v-spacer>
                    <v-btn text x-small color="primary" @click="dialogUnbalanced = true">Ver Descuadrados</v-btn>
                  </div>
                  <v-simple-table dense fixed-header height="300px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Código</th>
                          <th class="text-left">Fecha</th>
                          <th class="text-left">Tipo</th>
                          <th class="text-right">Monto Base</th>
                          <th class="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in dashboardData.outliers" :key="item.id">
                          <td class="font-weight-bold">{{ item.code }}</td>
                          <td>{{ moment(item.date).format('DD/MM/YYYY') }}</td>
                          <td><v-chip x-small>{{ item.type }}</v-chip></td>
                          <td class="text-right font-weight-black">{{ currencyFormat(item.amount) }}</td>
                          <td class="text-center">
                            <v-btn icon x-small color="primary" @click="viewEntry(item)">
                              <v-icon x-small>mdi-eye</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col> -->
            </v-row>
          </div>
          <div v-else-if="loadingDashboard" class="mt-8">
            <v-skeleton-loader type="heading, row, row, article" class="px-3"></v-skeleton-loader>
          </div>
        </v-fade-transition>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_search" width="950" transition="dialog-top-transition">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat color="primary" dark>
          <v-icon left>mdi-magnify</v-icon>
          <v-toolbar-title class="font-weight-bold">Búsqueda Rápida de Asientos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_search = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <v-row justify="center">
            <v-col cols="12">
              <v-text-field v-model="search" label="Ingrese Código de Asiento" placeholder="Ej: 385940"
                prepend-inner-icon="mdi-pound" outlined rounded filled dense class="search-input"
                v-on:keyup.enter="find_diary_book()" :loading="loading_search" :disabled="loading_search" clearable
                autofocus>
                <template v-slot:append>
                  <v-btn color="primary" small rounded depressed @click="find_diary_book()" :loading="loading_search"
                    class="px-4">
                    Buscar
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-fade-transition>
            <div v-if="search_found.length > 0">
              <div class="d-flex align-center mb-3">
                <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>
                <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Resultados
                  Encontrados</span>
              </div>
              <v-card outlined class="rounded-lg">
                <v-simple-table class="search-found-table">
                  <template v-slot:default>
                    <thead>
                      <tr class="grey lighten-4">
                        <th class="text-left font-weight-bold">Asiento</th>
                        <th class="text-left font-weight-bold">Tipo</th>
                        <th class="text-left font-weight-bold">Fecha</th>
                        <th class="text-right font-weight-bold">Monto</th>
                        <th class="text-center font-weight-bold">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in search_found" :key="item.diary_book_id" class="hover-row">
                        <td class="font-weight-bold primary--text text-no-wrap">{{ item.diary_book_code }}</td>
                        <td><v-chip small outlined>{{ item.diary_book_type_name }}</v-chip></td>
                        <td class="text-no-wrap">{{ moment(item.effective_date).format('DD/MM/YYYY') }}</td>
                        <td class="text-right font-weight-black success--text text-no-wrap">
                          {{ item.diary_book_details != null ? item.diary_book_details[0]?.currency_code : '' }}
                          {{ currencyFormat(sum_amount_diary_book_found(item.diary_book_details)) }}
                        </td>
                        <td class="text-center">
                          <v-btn icon small color="primary" @click="show_found(item)">
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </div>
            <div v-else-if="!loading_search && search && search_found.length === 0" class="text-center py-6">
              <v-icon size="48" color="grey lighten-2">mdi-text-box-search-outline</v-icon>
              <div class="text-body-2 grey--text mt-2">No se encontraron asientos con ese código.</div>
            </div>
            <div v-else class="text-center py-6 opacity-50">
              <v-icon size="48" color="grey lighten-3">mdi-keyboard-outline</v-icon>
              <div class="text-caption grey--text mt-2">Ingrese un código y presione Enter</div>
            </div>
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Asientos Descuadrados -->
    <v-dialog v-model="dialogUnbalanced" width="900" transition="dialog-bottom-transition">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat color="error" dark>
          <v-icon left>mdi-alert-circle</v-icon>
          <v-toolbar-title class="font-weight-bold">Asientos con Descuadre Detectado</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogUnbalanced = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-alert type="warning" text dense class="mb-4">
            Los siguientes asientos presentan una diferencia entre la suma de sus débitos y créditos en la moneda
            transaccional.
          </v-alert>

          <v-data-table :headers="unbalancedHeaders" :items="unbalancedEntries" :loading="loadingUnbalanced"
            class="elevation-0 modern-table" hide-default-footer :items-per-page="-1">
            <template v-slot:[`item.diary_book_code`]="{ item }">
              <v-chip color="primary" label small class="font-weight-bold cursor-pointer"
                @click="view_entry(item, true)">
                {{ item.diary_book_code }}
              </v-chip>
            </template>
            <template v-slot:[`item.diary_book_type_name`]="{ item }">
              <v-chip outlined x-small class="cursor-pointer" @click="showItem(item, true)">
                {{ item.diary_book_type_name }}
              </v-chip>
            </template>
            <template v-slot:[`item.total_debit`]="{ item }">
              <span class="success--text font-weight-bold">{{ currencyFormat(item.total_debit) }}</span>
            </template>
            <template v-slot:[`item.total_credit`]="{ item }">
              <span class="error--text font-weight-bold">{{ currencyFormat(item.total_credit) }}</span>
            </template>
            <template v-slot:[`item.difference`]="{ item }">
              <v-chip color="error lighten-5" text-color="error" small class="font-weight-black">
                {{ currencyFormat(item.difference) }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex align-center justify-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="view_entry(item, true)">
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Asiento</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.diary_book_type_id">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="orange" v-bind="attrs" v-on="on" @click="showItem(item, true)">
                      <v-icon small>mdi-file-document-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Documento Origen</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>

          <v-alert v-if="unbalancedEntries.length === 0 && !loadingUnbalanced" type="success" text class="mt-4 mb-0">
            <v-icon left color="success">mdi-check-circle</v-icon>
            ¡Excelente! No se encontraron asientos descuadrados en el rango seleccionado.
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4 grey lighten-5 border-top">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text large class="text-none" @click="dialogUnbalanced = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ExcelJS from "exceljs";
import moment from "moment";
import StatsCard from "@/components/base/StatsCard.vue";
import BarChart from "@/components/Charts/Bar.vue";
import PieChart from "@/components/Charts/Pie.vue";
import LineChart from "@/components/Charts/Line.vue";

export default {
  name: "DiaryBook",
  components: {
    StatsCard,
    BarChart,
    PieChart,
    LineChart,
  },

  data: () => ({
    diaryBookData: [],
    loading: false,
    loading_report: false,
    isInitializing: true,
    lastFilters: {},
    lastFiltersState: {},
    totalItems: 0,
    search: null,
    loading_search: false,
    dialog_search: false,
    search_found: [],
    diaryBookId: null,
    diary_book_code_find: null,
    business_filter: null,
    location_filter: 0,
    itemsBussines: [], // Lista de Unidades de Negocio
    locations: [],     // Lista de Locations filtradas

    // --- Variables de Filtro de Fecha ---
    dateStart_filter: moment().startOf("month").format("YYYY-MM-DD"),
    dateEnd_filter: moment().endOf("month").format("YYYY-MM-DD"),
    menu_dateStart_filter: false,
    menu_dateEnd_filter: false,
    rangeSelected_filter: "4",

    // --- NUEVOS FILTROS Y ESTADOS ---


    // Variable para Departamento seleccionado (usa el patrón anterior)
    // Selección múltiple: [] = Todos
    department_selected: [],
    currency_selected: [],
    multiSelectTimer: null,
    itemsDepartment: [], // Lista de Departamentos
    currencies: [], // Lista de monedas
    location_access: [],
    // Variables para las listas de Autocomplete
    accounts: [], // Cuentas contables
    type_accounts: [], // Tipos de libro (DIARY_BOOK_TYPES)
    categories: [], // Categorías y Subcategorías (DIARY_BOOK_CATEGORIES)
    summaryData: [],
    dashboardData: null,
    loadingDashboard: false,
    // Objeto consolidado de filtros para Cuenta, Tipo Libro, Categoría/Subcategoría
    dialogUnbalanced: false,
    loadingUnbalanced: false,
    unbalancedEntries: [],
    filters: {
      account: [], // chartOfAccount_filter (IDs de cuenta, [] = Todas)
      type_account: [], // Tipo Libro IDs (DIARY_BOOK_TYPE_ID, [] = Todas)
      category: null, // Categoría ID
      sub_category: null, // Subcategoría ID
      // PROPIEDADES DE PAGINACIÓN INTEGRADAS:
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },

    // Otros filtros (no implementados en UI, se mantienen por compatibilidad)
    entryType_filter: 0,

    dateRanges: [
      { text: "Hoy", value: "1" },
      { text: "Últimos 7 días", value: "3" },
      { text: "Últimos 30 días", value: "4" },
      { text: "Últimos 60 días", value: "8" },
      { text: "Últimos 90 días", value: "9" },
      { text: "Este año", value: "6" },
      { text: "Personalizado", value: "7" },
    ],
  }),

  computed: {
    dataPaginationOptions: {
      get() {
        return {
          page: this.filters.page,
          itemsPerPage: this.filters.itemsPerPage,
          // Vuetify espera arrays para sortBy y sortDesc, aunque solo uses el primer elemento
          sortBy: this.filters.sortBy,
          sortDesc: this.filters.sortDesc,
        };
      },
      set(newOptions) {
        // El setter recibe el objeto completo de options del v-data-table y actualiza 'filters'

        // Comprobación de cambios y actualización de 'filters'
        let changed = false;

        if (this.filters.page !== newOptions.page) {
          this.filters.page = newOptions.page;
          changed = true;
        }

        if (this.filters.itemsPerPage !== newOptions.itemsPerPage) {
          this.filters.itemsPerPage = newOptions.itemsPerPage;
          changed = true;
        }

        // Vuetify puede devolver arrays vacíos, lo manejamos.
        if (JSON.stringify(this.filters.sortBy) !== JSON.stringify(newOptions.sortBy)) {
          this.filters.sortBy = newOptions.sortBy || [];
          changed = true;
        }

        if (JSON.stringify(this.filters.sortDesc) !== JSON.stringify(newOptions.sortDesc)) {
          this.filters.sortDesc = newOptions.sortDesc || [];
          changed = true;
        }

        // Nota: No necesitas llamar a updateData(false) aquí, ya que los *watchers*
        //       de `filters.page` y `filters.itemsPerPage` (que ya implementamos)
        //       se encargarán de disparar la carga de datos.
      },
    },
    // Definición de las columnas de la tabla
    headers() {
      let head = [
        { text: "Asiento", value: "diary_book_code", class: "font-semibold" },
        { text: "Tipo de Asiento", value: "view_diary_type_detail", class: "font-semibold" },
        { text: "Ubicación", value: "location_description" },
        { text: "Fecha", value: "formatted_effective_date" },
        { text: "Entidad", value: "entity_name" },
        { text: "Cuenta Contable", value: "chart_of_account_name" },
        { text: "Departamento", value: "department_name" },
        { text: "Categoria", value: "category_name" },
        { text: "Sub categoria", value: "subcategory_name" },
        { text: "Debito", value: "debit", align: 'right' },
        { text: "Credito", value: "credit", align: 'right' },
      ];
      if (this.location_filter != 0) {
        head[2].align = ' d-none';
      }
      if (this.filters.account != null) {
        head[4].align = ' d-none';
      }
      if (this.department_selected.length > 0) {
        head[5].align = ' d-none';
      }

      if (this.filters.category != null) {
        head[6].align = ' d-none';
      }
      if (this.filters.sub_category != null) {
        head[7].align = ' d-none';
      }


      return head;
    },
    // Formato de fechas para mostrar en el input
    dateStart_filterDMY() {
      return moment(this.dateStart_filter).format("DD/MM/YYYY");
    },
    dateEnd_filterDMY() {
      return moment(this.dateEnd_filter).format("DD/MM/YYYY");
    },
    // Cálculo del número total de páginas (ACCEDE A FILTERS)
    pageCount() {
      return Math.ceil(this.totalItems / this.filters.itemsPerPage);
    },
    // Propiedad calculada para controlar la página actual (ACCEDE A FILTERS)
    currentPage: {
      get() {
        return this.filters.page;
      },
      set(value) {
        this.filters.page = value;
      },
    },
    groupedSummary() {
      if (!this.summaryData || this.summaryData.length === 0) return {};

      return this.summaryData.reduce((acc, item) => {
        const {
          currency_code,
          entry_type_name,
          total_amount_currency,
          total_base_amount
        } = item;

        // Inicializa el objeto para la moneda si no existe
        if (!acc[currency_code]) {
          acc[currency_code] = {
            DEBITO: null,
            CREDITO: null
          };
        }

        // Asigna los totales según el tipo de entrada
        if (entry_type_name === 'DEBITO') {
          acc[currency_code].DEBITO = {
            amount: parseFloat(total_amount_currency).toFixed(2),
            base: parseFloat(total_base_amount).toFixed(2)
          };
        } else if (entry_type_name === 'CREDITO') {
          acc[currency_code].CREDITO = {
            amount: parseFloat(total_amount_currency).toFixed(2),
            base: parseFloat(total_base_amount).toFixed(2)
          };
        }
        return acc;
      }, {});
    },
    baseAmountTotals() {
      let totalBaseDebit = 0;
      let totalBaseCredit = 0;

      if (!this.summaryData || this.summaryData.length === 0) {
        return { totalBaseDebit: 0, totalBaseCredit: 0 };
      }

      this.summaryData.forEach(item => {
        const baseAmount = parseFloat(item.total_base_amount);

        if (item.entry_type_name === 'DEBITO') {
          totalBaseDebit += baseAmount;
        } else if (item.entry_type_name === 'CREDITO') {
          totalBaseCredit += baseAmount;
        }
      });

      return {
        totalBaseDebit: totalBaseDebit,
        totalBaseCredit: totalBaseCredit,
        totalNeto: totalBaseDebit - totalBaseCredit
      };
    },
    unbalancedHeaders() {
      return [
        { text: "Código Asiento", value: "diary_book_code" },
        { text: "Tipo de Asiento", value: "diary_book_type_name" },
        { text: "Fecha", value: "formatted_date" },
        { text: "Total Débito (Base)", value: "total_debit", align: "right" },
        { text: "Total Crédito (Base)", value: "total_credit", align: "right" },
        { text: "Diferencia", value: "difference", align: "right" },
        { text: "Acciones", value: "actions", align: "center", sortable: false },
      ];
    },
    calculateManualPct() {
      if (!this.dashboardData || !this.dashboardData.stats.total_entries) return 0;
      return parseFloat(((this.dashboardData.stats.manual_entries / this.dashboardData.stats.total_entries) * 100).toFixed(1));
    },
    entriesTrend() {
      if (!this.dashboardData || !this.dashboardData.prevStats) return null;
      return this.calcTrend(this.dashboardData.stats.total_entries, this.dashboardData.prevStats.total_entries);
    },
    volumeTrend() {
      if (!this.dashboardData || !this.dashboardData.prevStats) return null;
      return this.calcTrend(this.dashboardData.stats.total_volume_base, this.dashboardData.prevStats.total_volume_base);
    }
  },

  watch: {
    // Watchers para Business, Location, Department, Account, Type, Category, Subcategory, EntryType
    business_filter(newValue) {
      if (!this.isInitializing) {
        this.$store.commit("setBusiness", newValue);
        this.updateLocationsForBusiness(); // Actualiza la lista de locations
        this.updateUrlAndLoadData(true);
      }
    },
    location_filter() {
      if (!this.isInitializing) {
        this.updateUrlAndLoadData(true);
      }
    },
    department_selected() {
      if (!this.isInitializing) this.scheduleMultiSelectUpdate();
    },
    currency_selected() {
      if (!this.isInitializing) this.scheduleMultiSelectUpdate();
    },
    'filters.account'() {
      if (!this.isInitializing) this.scheduleMultiSelectUpdate();
    },
    'filters.type_account'() {
      if (!this.isInitializing) this.scheduleMultiSelectUpdate();
    },
    'filters.category'() {
      if (!this.isInitializing) this.updateUrlAndLoadData(true);
    },
    'filters.sub_category'() {
      if (!this.isInitializing) this.updateUrlAndLoadData(true);
    },
    entryType_filter() {
      if (!this.isInitializing) this.updateUrlAndLoadData(true);
    },

    // Watcher para Rango de Fechas
    rangeSelected_filter(newValue) {
      if (!this.isInitializing) {
        this.applyRangeDates(newValue);
        if (newValue !== '7') {
          this.updateUrlAndLoadData(true);
        }
      }
    },
    // Watchers para Fechas Personalizadas
    dateStart_filter(newValue) {
      if (!this.isInitializing && this.rangeSelected_filter === "7" && moment(newValue, "YYYY-MM-DD", true).isValid()) {
        this.updateUrlAndLoadData(true);
      }
    },
    dateEnd_filter(newValue) {
      if (!this.isInitializing && this.rangeSelected_filter === "7" && moment(newValue, "YYYY-MM-DD", true).isValid()) {
        this.updateUrlAndLoadData(true);
      }
    },

    // Watchers para Paginación (Ahora observan las propiedades dentro de 'filters')
    'filters.page': {
      handler(newPage) {
        const oldPage = this.lastFiltersState.page || 1;
        // Se dispara SOLO si la página ha cambiado
        if (!this.isInitializing && newPage !== oldPage) {
          this.updateUrl(); // Guarda el nuevo número de página en la URL
          this.updateData(false); // Carga los datos, pero NO resetea la página
        }
      },
    },
    'filters.itemsPerPage': {
      handler(newItemsPerPage) {
        const oldItemsPerPage = this.lastFiltersState.itemsPerPage || 10;
        // Se dispara SOLO si los items por página han cambiado
        if (!this.isInitializing && newItemsPerPage !== oldItemsPerPage) {
          // Si cambian los items por página, la paginación de la UI lo maneja, solo recargamos
          this.updateUrl();
          this.updateData(false);
        }
      },
    },
    // Se mantiene el watch deep en el objeto filters para el resto de filtros.
    // Aunque ya tenemos watchers específicos, este puede ser un respaldo.
    // 'filters': {
    //     handler() {
    //         if (!this.isInitializing) this.updateUrlAndLoadData(true);
    //     },
    //     deep: true,
    // },
  },

  created() {
    for (let item of this.$store.state.auth.locations) {
      this.location_access.push(item.id);
    }
    // 1. Cargar filtros desde URL
    this.loadFiltersFromUrl();
    // 2. Inicializar Listas (Cuentas, Departamentos, Tipos, Categorías) y Datos
    this.getData();
  },

  methods: {
    // Con selección múltiple la lista queda abierta: esperar a que el usuario termine de marcar
    scheduleMultiSelectUpdate() {
      clearTimeout(this.multiSelectTimer);
      this.multiSelectTimer = setTimeout(() => {
        if (this.loading) {
          this.scheduleMultiSelectUpdate();
          return;
        }
        this.updateUrlAndLoadData(true);
      }, 600);
    },
    // Texto del chip: el nombre si es uno solo, "N <plural>" si son varios
    selectedLabel(items, values, valueKey, textKey, plural) {
      if (values.length === 1) {
        return items.find((i) => i[valueKey] === values[0])?.[textKey] || "";
      }
      return `${values.length} ${plural}`;
    },

    async getData() {
      try {
        this.loading = true;

        // Obtener tipos de cuentas (Tipo Libro)
        const typeAccounts = await this.api_Get("accounting/type_accounts");
        const result_types_accounts = await typeAccounts.json();
        this.type_accounts = result_types_accounts;

        // Obtener categorías
        const resultTypeCategories = await this.api_Get(
          "accounting/categories_diary_book"
        );
        this.categories = await resultTypeCategories.json();
        this.categories.unshift({ id: null, name: "Todas", parent_id: null });

        // Obtener cuentas contables
        const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
        const dataTypeAccounts = await resultTypeAccounts.json();

        this.accounts = dataTypeAccounts.map((item) => ({
          text: `${item.code} - ${item.name}`,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        }));

        // Obtener Departamentos
        this.itemsDepartment = (await this.g_departments()).filter((d) => d.value !== 0);

        // Inicializar Unidades de Negocio
        this.itemsBussines = [...(this.$store.state.auth.bussines_units || [])];

        const resultCurrencies = await this.api_Get("accounting/currencies");
        for (let item of await resultCurrencies.json()) {
          this.currencies.push({ text: item.code + ' - ' + item.description, value: item.id, code: item.code });
        }

        // Filtrar locations y aplicar rango de fechas inicial
        this.updateLocationsForBusiness();
        this.applyRangeDates(this.rangeSelected_filter, true);

        // Cargar datos iniciales. `false` porque la página ya fue cargada desde la URL (o es 1)
        this.loading = false;
        await this.updateData(false);
        this.isInitializing = false;
      } catch (error) {
        console.error("Error in getData:", error);
      } finally {
        this.loading = false;
      }
    },

    // Lógica para filtrar Locations cuando cambia el Business
    updateLocationsForBusiness() {
      const allLocations = this.$store.state.auth.locations || [];
      const busId = this.business_filter;

      // Filtra las locations por la Unidad de Negocio
      this.locations = allLocations
        .filter(loc => busId === 0 || loc.bus_id === busId)
        .map(loc => ({ text: loc.desc_loc_long, value: loc.id }));

      this.locations.unshift({ text: "Todas", value: 0 });

      // Si la ubicación seleccionada ya no es válida, la reseteamos a "Todas" (0)
      const currentSelectedValue = this.location_filter;
      const isValid = this.locations.some(loc => loc.value === currentSelectedValue);

      if (!isValid) {
        this.location_filter = 0;
      }
    },

    async fetchDiaryBookData(payload) {
      try {
        const dummyResponse = await this.api_Post(
          "accounting/show_diary_book_details",
          payload
        );

        if (dummyResponse.status === 200) {
          const response = await dummyResponse.json();
          return response;
        } else {
          console.error("Error al llamar al API:", dummyResponse.status);
          return { data: [], totalItems: 0 };
        }
      } catch (error) {
        console.error("Error de red o parsing:", error);
        return { data: [], totalItems: 0 };
      }
    },

    // 1. Recolecta todos los filtros de la UI y determina si hubo cambios
    collectAllFilters() {
      const currentFilters = {
        dateStart: this.dateStart_filter,
        dateEnd: this.dateEnd_filter,
        rangeSelected: this.rangeSelected_filter,

        businessId: this.business_filter,
        locationId: this.location_filter,

        currencyId: this.currency_selected,
        departmentId: this.department_selected,
        chartOfAccountId: this.filters.account,
        diaryBookTypeId: this.filters.type_account,
        categoryId: this.filters.category,
        subcategoryId: this.filters.sub_category,

        entryTypeId: this.entryType_filter,

        // Incluir paginación en el estado de filtros para la comparación
        page: this.filters.page,
        itemsPerPage: this.filters.itemsPerPage,
      };

      // Si queremos comparar SOLO los filtros sin paginación (para el reset de página)
      const lastFiltersWithoutPagination = { ...this.lastFilters };
      delete lastFiltersWithoutPagination.page;
      delete lastFiltersWithoutPagination.itemsPerPage;

      const currentFiltersWithoutPagination = { ...currentFilters };
      delete currentFiltersWithoutPagination.page;
      delete currentFiltersWithoutPagination.itemsPerPage;

      const filtersChanged = JSON.stringify(currentFiltersWithoutPagination) !== JSON.stringify(lastFiltersWithoutPagination);

      this.lastFilters = currentFilters; // Guarda el estado completo para la próxima comparación

      return { filters: currentFilters, filtersChanged };
    },

    // 2. Método principal para cargar datos al cambiar filtros o paginación
    async updateData(resetPageOnFilterChange = false, is_find = false) {
      // Si ya está cargando, lo ignoramos para evitar doble petición.
      if (this.loading) {
        return;
      }
      if (!is_find) {
        this.diaryBookId = null;
        this.diary_book_code_find = null;
      }
      this.loading = true;
      if (!this.business_filter) {
        this.diaryBookData = [];
        this.totalItems = 0;
        this.summaryData = [];
        this.loading = false;
        return;
      }

      const { filters, filtersChanged } = this.collectAllFilters();

      // CORRECCIÓN CRÍTICA: Si los filtros (sin contar paginación) cambiaron Y debemos resetear la página...
      if (filtersChanged && resetPageOnFilterChange) {
        this.filters.page = 1;
      }



      // Construye el payload combinando filtros y paginación
      const payload = {
        ...filters,
        // La paginación ya está incluida en el objeto 'filters'
        page: this.filters.page,
        itemsPerPage: this.filters.itemsPerPage,
        sortBy: this.filters.sortBy[0],
        sortDesc: this.filters.sortDesc[0],
        location_access: this.location_access,
        diaryBookId: this.diaryBookId
      };

      this.updateUrl();

      try {
        const response = await this.fetchDiaryBookData(payload);
        this.diaryBookData = response.data || [];
        this.totalItems = response.totalItems || 0;
        this.summaryData = response.summary || [];

        // Guardar las opciones de paginación/filtros para evitar un loop en el watcher
        this.lastFiltersState = JSON.parse(JSON.stringify(this.filters)); // Usa el nuevo nombre

        // CARGAR DASHBOARD (Sin await para no bloquear la tabla)
        this.updateDashboard(filters);
      } catch (error) {
        console.error("Error al cargar los datos del diario contable:", error);
        this.diaryBookData = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },

    // 3. Lógica de URL y Carga de Datos (Llamado por los Watchers de filtros)
    updateUrlAndLoadData(forceResetPage = true) {
      this.updateData(forceResetPage); // Pasa 'true' para forzar el reset de página
    },

    // 4. Lógica de Rango de Fechas
    applyRangeDates(rangeValue, isInitialLoad = false) {
      let dateStart = null;
      let dateEnd = null;
      const format = "YYYY-MM-DD";

      const today = moment().format(format);
      switch (rangeValue) {
        case "1": // Hoy
          dateStart = dateEnd = today;
          break;
        case "3": // Últimos 7 días
          dateStart = moment().subtract(7, "days").format(format);
          dateEnd = today;
          break;
        case "4": // Últimos 30 días
          dateStart = moment().subtract(30, "days").format(format);
          dateEnd = today;
          break;
        case "8": // Últimos 60 días
          dateStart = moment().subtract(60, "days").format(format);
          dateEnd = today;
          break;
        case "9": // Últimos 90 días
          dateStart = moment().subtract(90, "days").format(format);
          dateEnd = today;
          break;
        case "6": // Este año
          dateStart = moment().startOf("year").format(format);
          dateEnd = moment().endOf("year").format(format);
          break;
        case "7": // Personalizado
          return;
        default:
          if (isInitialLoad && !this.dateStart_filter) {
            dateStart = moment().subtract(30, "days").format(format);
            dateEnd = today;
          }
          break;
      }

      if (dateStart && dateEnd) {
        // Solo actualiza si hay un cambio real para evitar bucles en watchers
        if (this.dateStart_filter !== dateStart || this.dateEnd_filter !== dateEnd) {
          this.dateStart_filter = dateStart;
          this.dateEnd_filter = dateEnd;
        }
      }
    },

    // 5. Carga de Filtros desde URL (ACTUALIZADO para PAGINACIÓN en 'filters')
    loadFiltersFromUrl() {
      const query = this.$route.query;

      const applyParam = (paramName, dataProp, isNumber = true) => {
        const value = query[paramName];
        if (value !== undefined) {
          const finalValue = isNumber ? (Number(value) || 0) : value;

          if (dataProp.includes('.')) {
            // Manejo de filtros anidados (filters.account, filters.page, etc.)
            const [objName, propName] = dataProp.split('.');

            // Lógica para 'Todas' (0 -> null)
            if (['type_account', 'category', 'sub_category'].includes(propName) && finalValue === 0) {
              this.$set(this.filters, propName, null);
            }
            // Lógica para Paginación (si es número y diferente del actual)
            else if (['page', 'itemsPerPage'].includes(propName) && this.filters[propName] !== finalValue) {
              this.$set(this.filters, propName, finalValue);
            }
            // Lógica para el resto de filtros anidados
            else if (this.filters[propName] !== finalValue) {
              this.$set(this.filters, propName, finalValue);
            }
          } else if (this[dataProp] !== finalValue) {
            this[dataProp] = finalValue;
          }
        }
      };

      // Filtros principales (usan 0 como 'Todas')
      applyParam('businessId', 'business_filter');
      applyParam('locationId', 'location_filter');
      // Selección múltiple: "1,2,3" en la URL
      const idList = (value) =>
        String(value ?? "")
          .split(",")
          .map((v) => parseInt(v, 10))
          .filter((n) => Number.isInteger(n) && n > 0);
      if (query.currencyId !== undefined) this.currency_selected = idList(query.currencyId);
      if (query.departmentId !== undefined) this.department_selected = idList(query.departmentId);
      if (query.chartOfAccountId !== undefined) this.filters.account = idList(query.chartOfAccountId);
      if (query.diaryBookTypeId !== undefined) this.filters.type_account = idList(query.diaryBookTypeId);
      applyParam('entryTypeId', 'entryType_filter');

      // Filtros que usan 'null' como 'Todas' (deben ser 0 en URL si se deseleccionan)
      applyParam('categoryId', 'filters.category');
      applyParam('subcategoryId', 'filters.sub_category');

      // Fechas y Rango (cadenas)
      applyParam('dateStart', 'dateStart_filter', false);
      applyParam('dateEnd', 'dateEnd_filter', false);
      applyParam('range', 'rangeSelected_filter', false);

      // Paginación (Ahora mapea a filters)
      applyParam('limit', 'filters.itemsPerPage');
      applyParam('page', 'filters.page');

      // Si no hay unidad de negocio en la URL, tomar la del store
      if (!query.businessId && this.$store.state.app.filters.business) {
        this.business_filter = this.$store.state.app.filters.business;
      }
    },

    // 6. Actualización de URL (ACTUALIZADO para PAGINACIÓN en 'filters')
    updateUrl() {
      const query = {
        dateStart: this.dateStart_filter,
        dateEnd: this.dateEnd_filter,
        range: this.rangeSelected_filter,

        businessId: this.business_filter,
        locationId: this.location_filter,

        // Nuevos filtros
        currencyId: this.currency_selected.join(","),
        departmentId: this.department_selected.join(","),
        chartOfAccountId: this.filters.account.join(","),
        diaryBookTypeId: this.filters.type_account.join(","),
        categoryId: this.filters.category,
        subcategoryId: this.filters.sub_category,

        entryTypeId: this.entryType_filter,

        // Paginación (Accede a filters)
        page: this.filters.page,
        limit: this.filters.itemsPerPage,
        sortBy: this.filters.sortBy[0],
        sortDesc: this.filters.sortDesc[0],
      };

      const cleanQuery = Object.fromEntries(
        Object.entries(query).filter(([key, v]) => {
          // Remueve null, undefined, y cadenas vacías
          if (v === undefined || v === null || v === "") return false;

          // Remove page=1 (default)
          if (key === 'page' && Number(v) <= 1) return false;

          // Remove filter IDs that are 0 (default for Business, Location, Department, Account, EntryType)
          if (['businessId', 'locationId', 'departmentId', 'chartOfAccountId', 'entryTypeId'].includes(key)) {
            return Number(v) !== 0;
          }

          // Remove filter IDs that are 0 (which also represents 'null' for Type/Category after selection)
          if (['diaryBookTypeId', 'categoryId', 'subcategoryId'].includes(key)) {
            return Number(v) !== 0;
          }

          // Keep everything else (dates, limit, sort, etc.)
          return true;
        })
      );

      this.$router.replace({ query: cleanQuery }).catch(() => { });
    },
    view_entry(item) {
      let route = this.$router.resolve({ name: "ViewEntryDetail", params: { id: item.diary_book_id }, });
      window.open(route.href);
    },
    showItem(item) {
      // Lógica existente de showItem para navegar...
      if (item.diary_book_type_id == 1 || item.diary_book_type_id == 3 || item.diary_book_type_id == 16 || item.diary_book_type_id == 17) {
        this.showInvoice(item.invoice_id, true);
        return;
      }

      if (item.diary_book_type_id == 18) {
        this.viewOutflow(item.outflow_id);
        return;
      }
      if (item.diary_book_type_id == 4) {
        let route = this.$router.resolve({
          name: "ViewPaymentsCxC",
          params: { id: item.payment_id },
        });
        window.open(route.href);
        return;
      }

      if (item.diary_book_type_id == 5) {
        let route = this.$router.resolve({
          name: "ViewEntryPayroll",
          params: { id: item.diary_book_id },
        });
        window.open(route.href);
        return;
      }

      if (item.diary_book_type_id == 7) {
        let route = this.$router.resolve({
          name: "ViewDirectPayment",
          params: { id: item.prepayment_id },
        });
        window.open(route.href);
        return;
      }

      if (item.diary_book_type_id == 8) {
        let route = this.$router.resolve({
          name: "ViewAdjustment",
          params: { id: item.warehouse_adjustment_id },
        });
        window.open(route.href);
        return;
      }

      if (item.diary_book_type_id == 10) {
        let route = this.$router.resolve({
          name: "ViewRevaluation",
          params: { id: item.diary_book_id },
        });
        window.open(route.href);
        return;
      }
      if (item.diary_book_type_id == 12) {
        this.viewReception(item.order_id, item.order_entry_id, true)
        return;
      }
      if (item.diary_book_type_id == 13 || item.diary_book_type_id == 14) {
        this.showNote(item.invoice_note_id, true)
        return;
      }
      let route = this.$router.resolve({ name: "ViewEntryDetail", params: { id: item.diary_book_id }, });
      window.open(route.href);
      return;
    },
    viewOutflow(id) {
      let route = this.$router.resolve({
        name: "ViewOutflows",
        params: { id: id },
      });

      window.open(route.href, "_blank");
    },
    async find_diary_book() {
      this.loading_search = true;
      try {
        const response = await this.api_Post("accounting/diary_entry_data", {
          search: this.search,
          location_access: this.location_access
        });
        if (response.status === 200) {
          this.search_found = await response.json();
        } else {
          this.search_found = [];
        }
      } catch (error) {
        console.error("Error searching diary book:", error);
        this.search_found = [];
      } finally {
        this.loading_search = false;
      }
    },
    sum_amount_diary_book_found(amounts) {
      if (!amounts || amounts.length === 0) {
        return 0;
      }
      return amounts.reduce((accumulator, item) => {
        if (item.entry_type_id === 1) {
          const amount = parseFloat(item.amount) || 0;
          return accumulator + amount;
        }
        return accumulator;
      }, 0);
    },
    async show_found(diary_book) {
      this.dialog_search = false;
      // Silenciar los watchers mientras se limpian los filtros: si no, sus recargas
      // (algunas con debounce) llegan después y borran el asiento buscado.
      this.isInitializing = true;
      clearTimeout(this.multiSelectTimer);
      this.reset_filters();
      this.applyRangeDates(this.rangeSelected_filter);
      await this.$nextTick();
      this.isInitializing = false;

      this.diaryBookId = diary_book.diary_book_id;
      this.diary_book_code_find = diary_book.diary_book_code;
      this.updateData(true, true);
    },
    reset_filters() {
      this.currency_selected = [];
      this.department_selected = [];
      this.filters.account = [];
      this.filters.type_account = [];
      this.filters.category = null;
      this.filters.sub_category = null;
      this.entryType_filter = 0;
      this.rangeSelected_filter = "4";
    },
    reset_find() {
      this.diaryBookId = null;
      this.diary_book_code_find = null;
      this.updateData(true);
    },
    async exportDiaryBookToExcel() {
      const { filters, filtersChanged } = this.collectAllFilters();
      const payload = {
        ...filters,
        location_access: this.location_access,
        diaryBookId: this.diaryBookId
      };
      this.loading_report = true;
      let data = [];
      try {
        const dummyResponse = await this.api_Post(
          "accounting/report_diary_book_details",
          payload
        );

        if (dummyResponse.status != 200) {
          console.error(dummyResponse.message);
          this.loading_report = false
          return;
        }
        data = await dummyResponse.json();
      } catch (error) {
        console.error("Error de red o parsing:", error.message);
        this.loading_report = false
        return;
      }


      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Libro Diario')

      // =========================
      // Columnas
      // =========================
      worksheet.columns = [
        { header: 'ID', key: 'diary_book_id', width: 14 },
        { header: 'Tipo de Entrada', key: 'diary_book_type_name', width: 22 },
        { header: 'Asiento', key: 'diary_book_code', width: 22 },

        { header: 'Cuenta Contable', key: 'chart_of_account_name', width: 40 },
        { header: 'Tipo Movimiento', key: 'entry_type_name', width: 18 },

        { header: 'Monto', key: 'amount', width: 18 },
        { header: 'Monto Base', key: 'base_amount', width: 20 },

        { header: 'Departamento', key: 'department_name', width: 18 },
        { header: 'Entidad', key: 'entity_name', width: 30 },
        { header: 'Localidad', key: 'location_description', width: 30 },

        { header: 'Moneda', key: 'currency_code', width: 10 },
        { header: 'Categoría', key: 'category_name', width: 18 },
        { header: 'Subcategoría', key: 'subcategory_name', width: 18 },

        { header: 'Fecha Efectiva', key: 'effective_date', width: 16 },
        { header: 'Nota', key: 'note', width: 30 }
      ]
      worksheet.getColumn('amount').numFmt = '#,##0.00'
      worksheet.getColumn('base_amount').numFmt = '#,##0.00'

      // =========================
      // Data
      // =========================
      data.forEach(entry => {
        worksheet.addRow({
          diary_book_id: entry.diary_book_id,
          diary_book_type_name: entry.diary_book_type_name,
          diary_book_code: entry.diary_book_code,

          chart_of_account_name: entry.chart_of_account_name,
          entry_type_name: entry.entry_type_name,

          amount: parseFloat(entry.amount),
          base_amount: parseFloat(entry.base_amount),

          department_name: entry.department_name,
          entity_name: entry.entity_name,
          location_description: entry.location_description,

          currency_code: entry.currency_code,
          category_name: entry.category_name,
          subcategory_name: entry.subcategory_name,

          effective_date: entry.effective_date,
          note: entry.note
        })
      })

      // =========================
      // Estilos
      // =========================
      worksheet.getRow(1).font = { bold: true }
      worksheet.autoFilter = 'A1:O1'

      worksheet.columns.forEach(col => {
        col.alignment = { vertical: 'middle', horizontal: 'left' }
      })

      // =========================
      // Exportar
      // =========================
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      //{{report_title.title}} {{report_title.is_default?'':report_title.union+report_title.origin+' '+report_title.date_format}}
      link.download = `reporte_libro_diario_${new Date().toISOString().slice(0, 10)}.xlsx`;
      link.click();
      this.loading_report = false
    },
    async findUnbalancedEntries() {
      this.loadingUnbalanced = true;
      try {
        const payload = {
          dateStart: this.dateStart_filter,
          dateEnd: this.dateEnd_filter,
          businessId: this.business_filter,
          locationId: this.location_filter,
          location_access: this.location_access
        };
        const response = await this.api_Post("accounting/find_unbalanced_diary_entries", payload);
        if (response.status === 200) {
          this.unbalancedEntries = await response.json();
          this.dialogUnbalanced = true;
        } else {
          const errorData = await response.json();
          console.error("Error finding unbalanced entries:", errorData.message);
        }
      } catch (error) {
        console.error("Error finding unbalanced entries:", error);
      } finally {
        this.loadingUnbalanced = false;
      }
    },
    goToEntryDetail(item) {
      window.open(`/#/accounting/view_entry_detail/${item.diary_book_id}`, '_blank');
    },
    async updateDashboard(filters) {
      if (this.loadingDashboard) return;
      this.loadingDashboard = true;
      try {
        const payload = {
          dateStart: filters.dateStart,
          dateEnd: filters.dateEnd,
          businessId: filters.businessId,
          locationId: filters.locationId,
          currencyId: filters.currencyId,
          departmentId: filters.departmentId,
          chartOfAccountId: filters.chartOfAccountId,
          diaryBookTypeId: filters.diaryBookTypeId,
          categoryId: filters.categoryId,
          subcategoryId: filters.subcategoryId,
          entryTypeId: filters.entryTypeId,
          location_access: this.location_access,
        };
        const responseData = await this.api_Post("accounting/diary_book_dashboard", payload);
        if (responseData.status === 200) {
          const raw = await responseData.json();
          // Fallback para usuarios y estructura financiera
          if (!raw.users) raw.users = { label: [], series: [] };
          if (!raw.financialStructure) raw.financialStructure = { label: [], series: [] };
          this.dashboardData = raw;
        }
      } catch (e) {
        console.error("Error loading dashboard", e);
      } finally {
        this.loadingDashboard = false;
      }
    },
    calcTrend(curr, prev) {
      curr = parseFloat(curr || 0);
      prev = parseFloat(prev || 0);
      if (prev === 0) return { val: 0, icon: 'mdi-minus', color: 'grey--text' };
      const diff = ((curr - prev) / prev) * 100;
      if (diff > 0) return { val: Math.abs(diff).toFixed(1), icon: 'mdi-arrow-up', color: 'success--text' };
      if (diff < 0) return { val: Math.abs(diff).toFixed(1), icon: 'mdi-arrow-down', color: 'error--text' };
      return { val: 0, icon: 'mdi-minus', color: 'grey--text' };
    },
    onOriginSelection(event) {
      // Drill-down logic: Filtrar por el tipo seleccionado en el pie chart
      if (event && event.label) {
        const type = this.type_accounts.find(t => t.description === event.label);
        if (type) {
          this.filters.type_account = [type.id];
        }
      }
    },
    onAccountSelection(event) {
      if (event && event.label) {
        // Buscar la cuenta por nombre
        const account = this.accounts.find(
          (a) => a.text === event.label || a.text.endsWith(" - " + event.label)
        );
        if (account) {
          this.filters.account = [account.value];
        }
      }
    },
    viewEntry(item) {
      // Búsqueda rápida y visualización del asiento seleccionado desde las anomalías
      this.diaryBookId = item.id;
      this.diary_book_code_find = item.code;
      this.updateData(false, true);
    },
    moment,
    currencyFormat(value) {
      return new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    },
  },
};
</script>

<style scoped>
.search-found-table th,
.search-found-table td {
  padding: 10px 16px !important;
  height: 52px !important;
}

.date-range-wrapper {
  display: flex;
  align-items: center;
  background: rgba(25, 118, 210, 0.04);
  border: 1px solid rgba(25, 118, 210, 0.25);
  border-radius: 8px;
  padding: 2px 6px;
}

.date-input {
  min-width: 140px;
  max-width: 160px;
}

.date-input >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  min-height: 40px !important;
}

.date-input >>> fieldset {
  border: none !important;
}

.date-input >>> .v-input__prepend-inner {
  margin-top: 8px;
  margin-right: 4px;
}

.date-separator {
  flex-shrink: 0;
  margin: 0 4px;
}

.modern-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  background: white !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.modern-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.border-bottom {
  border-bottom: 1px solid #f1f5f9 !important;
}

.border-top {
  border-top: 1px solid #f1f5f9 !important;
}

.font-weight-black {
  font-weight: 900 !important;
}

.text-overline {
  letter-spacing: 0.15em !important;
  line-height: 1rem !important;
}

.border-error {
  border: 1px solid #ff5252;
  border-radius: 8px;
}

.cursor-pointer {
  cursor: pointer;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.text-blue-800 {
  color: #1e40af;
}

/* Estilos para el footer personalizado y select de filas */
.v-data-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 8px 16px;
}

.v-data-footer__select {
  display: flex;
  align-items: center;
}

.v-data-footer__select .v-select {
  max-width: 80px;
}

.hover-row:hover {
  background-color: #f8fafc !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-input .v-input__slot {
  background-color: #f8fafc !important;
}

.search-input.v-input--is-focused .v-input__slot {
  background-color: #ffffff !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
}
</style>